import styled from "styled-components";

const ChildList = styled.ul`
  padding-left: 0;
  list-style: none;
`;

export default ChildList;
